"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageResizer = void 0;
var lodash_1 = require("lodash");
var blueimp_load_image_1 = __importDefault(require("blueimp-load-image"));
var IMAGE_QUALITY = 0.8;
var IMAGE_MIME_TYPE = 'image/jpeg'; // FIXME: 一旦固定
var ERROR_PREFIX = 'ImageResizerError: ';
var ImageResizer = /** @class */ (function () {
    function ImageResizer() {
    }
    ImageResizer.resize = function (file, maxWidth, maxHeight, onDone, onError // eslint-disable-line no-unused-vars
    ) {
        if (onError === void 0) { onError = function (e) { }; }
        (0, blueimp_load_image_1.default)(file, function (canvas) {
            if (canvas instanceof HTMLCanvasElement) {
                onDone(canvas.toDataURL(IMAGE_MIME_TYPE, IMAGE_QUALITY));
            }
            else {
                ImageResizer.resizeOnMyOwn(file, maxWidth, maxHeight, onDone, onError);
            }
        }, { maxWidth: maxWidth, maxHeight: maxHeight, orientation: true, canvas: true });
    };
    // 原因はよく分からないが blueimp-load-image がなぜかしくじることがあるので、リトライをかける
    // (Docker で実行している CI spec でのみ確認)
    // リトライでは画像の orientation の処理を省略している
    // これもまた原因はよく分からないが、 blueimp-load-image の方が画質が綺麗な気がする
    ImageResizer.resizeOnMyOwn = function (file, maxWidth, maxHeight, onDone, onError // eslint-disable-line no-unused-vars
    ) {
        if (onError === void 0) { onError = function (e) { }; }
        if (typeof FileReader === 'undefined' || typeof Image === 'undefined') {
            onError(ImageResizer.createError('画像の処理に失敗しました。申し訳ありませんが、最新のブラウザをご利用ください。'));
        }
        var reader = new FileReader();
        var image = new Image();
        reader.onload = function (event) {
            image.onload = function () {
                try {
                    var canvas = document.createElement('canvas');
                    var context = canvas.getContext('2d');
                    var scale = Math.min(maxWidth / image.width, maxHeight / image.height, 1);
                    var destinationWidth = image.width * scale;
                    var destinationHeight = image.height * scale;
                    if (context) {
                        canvas.width = destinationWidth;
                        canvas.height = destinationHeight;
                        context.drawImage(image, 0, 0, image.width, image.height, 0, 0, destinationWidth, destinationHeight);
                        onDone(canvas.toDataURL(IMAGE_MIME_TYPE, IMAGE_QUALITY));
                    }
                }
                catch (e) {
                    onError(e);
                }
            };
            image.onerror = function () {
                onError(ImageResizer.createError('非対応の画像です。'));
            };
            image.src = event.target.result; // FIXME: 型分からん
        };
        reader.onerror = function () {
            onError(ImageResizer.createError('非対応のファイルです。'));
        };
        reader.readAsDataURL(file);
    };
    // JavaScript は普通には独自の例外を定義できないので、プレフィックスで判定
    ImageResizer.createError = function (message) {
        return new Error(ERROR_PREFIX + message);
    };
    ImageResizer.isImageResizerError = function (error) {
        return (0, lodash_1.startsWith)(error.message, ERROR_PREFIX);
    };
    ImageResizer.errorMesssage = function (error) {
        return error.message.split(ERROR_PREFIX, 2)[1];
    };
    return ImageResizer;
}());
exports.ImageResizer = ImageResizer;
